



























































































import Vue, { PropType } from 'vue';
import {
  Configuration,
  ConfigurationItem
} from '@/models/configurator/configuration';

import { DataTableHeader } from 'vuetify';
import { roundCurrency } from '@/utils/helpers';

export default Vue.extend({
  props: {
    configuration: {
      type: Object as PropType<Configuration>
    },

    configurationItems: {
      type: Array as PropType<ConfigurationItem[]>
    },

    exchangeRate: Number,
    currencyCode: String,
    isModuleConfigurable: Boolean
  },

  data: () => ({
    search: '',
    configurationItemsHeaders: [
      {
        text: '',
        value: 'item_flag',
        align: 'center',
        sortable: false,
        width: 20,
        class: 'px-0'
      },
      {
        text: 'Items',
        align: 'start',
        sortable: false,
        value: 'item',
        groupable: false
      },
      {
        text: 'Category',
        value: 'category',
        sortable: false,
        groupable: true
      },
      {
        text: 'Unit Price',
        value: 'unit_price',
        sortable: false,
        width: '300',
        groupable: false
      },
      {
        text: 'Quantity',
        value: 'quantity',
        sortable: false,
        width: '200',
        groupable: false
      },
      {
        text: 'U/M',
        align: 'start',
        value: 'unit',
        sortable: false,
        width: '120',
        groupable: false
      },
      {
        text: 'Sub Total',
        value: 'subtotal',
        sortable: false,
        width: '120',
        groupable: false
      }
    ] as DataTableHeader[]
  }),

  methods: {
    roundCurrency,

    destroyConfigurationItem(item: ConfigurationItem) {
      this.$emit('delete:item', item);
    },

    updateConfigurationItemByQuantity(item: ConfigurationItem) {
      this.$emit('update:quantity', item);
    }
  },

  mounted() {
    const accessoryTable = this.$refs.accessoryTable as any;

    if (accessoryTable) {
      // Collapse all groups by default
      // Code taken from https://stackoverflow.com/a/63155363
      const keys = Object.keys(
        accessoryTable.$vnode.componentInstance.openCache
      );
      keys.forEach(x => {
        accessoryTable.$vnode.componentInstance.openCache[x] = false;
      });
    }
  }
});
